"use client"

import { loadTranslations, syncI18nLanguage } from "@/languages/i18n"
import { useParams } from "next/navigation"
import { useEffect } from "react"

type I18nSyncProps = {
  locale?: string
}

export const I18nSync = ({ locale: localeProp }: I18nSyncProps) => {
  const params = useParams()
  const locale = localeProp || (params?.locale as string | undefined)
  const syncedLocale = syncI18nLanguage(locale)

  useEffect(() => {
    void loadTranslations(syncedLocale).catch(error => {
      console.warn("Failed to refresh translations from API, using fallback resources.", error)
    })
  }, [syncedLocale])

  return null
}
